export const rootLinks = {
  root: () => '/',
  inner: () => '/app',
};
